import {svgIconWrapper} from '../svg-icon-wrapper';

import WufooRegular from './wufoo-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <WufooRegular {...rest} />;
}

SvgComponent.iconName = 'wufooRegular';

export const WufooRegularIcon = svgIconWrapper(SvgComponent);
